import * as React from 'react';
import AvatarPlus from "../common/AvatarPlus";

const style = {
    marginLeft: '-0.5em'
};

interface ITopVotersProps {
    voters : Array<any>;
    clickHandler(event : any): void;
}

class TopVoters extends React.Component<ITopVotersProps, any> {
    constructor(props: ITopVotersProps) {
        super(props);
    }

    render() {

        const {voters} = this.props;

        if (voters.length < 1)
            return null;

        const top4 = voters
            .slice(0, 4)
            .map(voter => (
                <span key={voter.createdBy.username} style={style}>
                    <AvatarPlus
                        size={20}
                        src={voter.createdBy.picture}
                    />
                </span>
            ));

        return (
            <div onClick={this.props.clickHandler}>
                {top4}
            </div>
        );
    }

}

export default TopVoters;



// WEBPACK FOOTER //
// ./components/voters/TopVoters.tsx